import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class S3ApiService {
  constructor(private readonly http: HttpClient) {}

  upload(url: string, formData: FormData): Observable<void> {
    return this.http.post<void>(url, formData);
  }
}
